import { vmPropTypes } from '../../global-prop-types';
import { memo } from 'react';

const Loading = memo(function Loading(props) {
  const { styles, debugConsole } = props;
  if (debugConsole && process.env.NODE_ENV === 'development') {
    console.log('Loading', debugConsole);
  }

  return (
    <div className="d-flex justify-content-center" style={styles?.wrapper}>
      <div className="spinner-border m-5" role="status" style={styles?.spinner}>
        <span className="sr-only loading-icon" style={styles?.icon} />
      </div>
    </div>
  );
});

Loading.vmPropTypes = {
  debugConsole: vmPropTypes.string,
  styles: {
    wrapper: vmPropTypes.styles,
    spinner: vmPropTypes.styles,
    icon: vmPropTypes.styles
  }
};

export default Loading;
